import { isDealWonStage } from './dealStageUtils';

/** مرحله سرنخ پس از تبدیل به معامله */
export const LEAD_STEP_CONVERTED_TO_DEAL = 'converted to deal';

/** ترتیب مراحل سرنخ مطابق کانبان */
export const LEAD_STEPS = [
  { value: 'new', label: 'جدید', dotColor: '#1890ff', tagColor: 'blue' },
  { value: 'in progress', label: 'در حال پیگیری', dotColor: '#faad14', tagColor: 'orange' },
  { value: 'approved', label: 'تایید شده', dotColor: '#52c41a', tagColor: 'green' },
  { value: 'rejected', label: 'رد شده', dotColor: '#ff4d4f', tagColor: 'red' },
  { value: LEAD_STEP_CONVERTED_TO_DEAL, label: 'تبدیل شده به معامله', dotColor: '#52c41a', tagColor: 'green' },
];

const stepMap = Object.fromEntries(LEAD_STEPS.map((s) => [s.value, s]));

export const getLeadStepMeta = (step) =>
  stepMap[step] || { value: step, label: step, dotColor: '#d9d9d9', tagColor: 'default' };

export const getLeadStepLabel = (step) => getLeadStepMeta(step).label;

export const getLeadStepTagColor = (step) => getLeadStepMeta(step).tagColor;

export const getLeadStepDotColor = (step) => getLeadStepMeta(step).dotColor;

export const isLeadConvertedToDeal = (step) => step === LEAD_STEP_CONVERTED_TO_DEAL;

export const isLeadClosedStep = (step) =>
  step === 'rejected' || step === 'approved' || isLeadConvertedToDeal(step);

const LOST_STEP_KEYWORDS = [
  'rejected',
  'lost',
  'fail',
  'unsuccessful',
  'ناموفق',
  'باخت',
  'رد شده',
];

export const isLeadLostStep = (column = {}) => {
  if (isDealWonStage(column)) return false;
  const text = [column.id, column.title, column.name, column.slug]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return LOST_STEP_KEYWORDS.some((keyword) => text.includes(keyword.toLowerCase()));
};
